module.exports = __webpack_public_path__ + "static/media/256x256.7648811f.gif";